import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronLeft = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            d="M8.66671 12C8.67188 11.8548 8.73655 11.7108 8.86103 11.5997L14.1989 6.84042C14.4579 6.6088 14.8788 6.6088 15.1385 6.84042C15.3983 7.07137 15.3983 7.44659 15.1385 7.67823L10.2914 12L15.1385 16.3218C15.3983 16.5535 15.3983 16.9287 15.1385 17.1596C14.8788 17.3913 14.4579 17.3913 14.1989 17.1596L8.86103 12.4003C8.73653 12.2893 8.67185 12.1453 8.66671 12Z"
            fill={color}
        />
    </StarryUIIcon>
);
